import React from "react";
import BlogData from "./BlogData/BlogData";


const Blog = (props:any) => {
    const { contents, loading, setCurrentBlogName, navigateToPost, setWhichPageChild } = props;
    React.useEffect(() => {
        window.onload = setWhichPageChild('blog')
    }, [])
    return (
         <BlogData 
         setCurrentBlogName={setCurrentBlogName} 
         contents={contents} 
         navigateToPost={navigateToPost}
         style={{marginTop: 10}}
         />        
    );
}
export default Blog;